import { Box, styled } from "@mui/material";

export const BannerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$height" && prop !== "$isFixed",
})<{ $height?: number; $isFixed?: boolean }>(({ $height, $isFixed }) => ({
  position: $isFixed ? "fixed" : "relative",
  top: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: $height,
  zIndex: 500,
  insetInlineStart: 0, // Ensures it starts at left edge, not offset by LeftPanel
}));
